import { useModal } from '@capturi/use-modal'
import { Button } from '@chakra-ui/react'
import { FC } from 'react'
import { CopilotConfigModal } from './CopilotConfigModal'
export const CopilotConfig: FC = () => {
  const [openCopilotConfigModal] = useModal(CopilotConfigModal)
  return <Button onClick={openCopilotConfigModal}>Open</Button>
}
